import { render, staticRenderFns } from "./determineContent.vue?vue&type=template&id=50465ba8&scoped=true&"
import script from "./determineContent.vue?vue&type=script&lang=js&"
export * from "./determineContent.vue?vue&type=script&lang=js&"
import style0 from "./determineContent.vue?vue&type=style&index=0&id=50465ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50465ba8",
  null
  
)

export default component.exports